import * as React from "react";
const SvgFiRrTeamCheckAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-team-check-alt_svg__a)">
      <path
        fill="#062147"
        d="M14.5 7C16.43 7 18 5.43 18 3.5S16.43 0 14.5 0 11 1.57 11 3.5 12.57 7 14.5 7m0-5c.827 0 1.5.673 1.5 1.5S15.327 5 14.5 5 13 4.327 13 3.5 13.673 2 14.5 2m-9 5C7.43 7 9 5.43 9 3.5S7.43 0 5.5 0 2 1.57 2 3.5 3.57 7 5.5 7m0-5C6.327 2 7 2.673 7 3.5S6.327 5 5.5 5 4 4.327 4 3.5 4.673 2 5.5 2m-.39 8.021a3.52 3.52 0 0 0-3.088 3.089 1 1 0 0 1-.993.89c-.717 0-1.056-.562-.996-1.11.281-2.534 2.323-4.576 4.857-4.856a1.01 1.01 0 0 1 1.104.885 1 1 0 0 1-.884 1.104zm3.906 3.985a1 1 0 0 1-.729.314 1 1 0 0 1-.685-.271 3.51 3.51 0 0 1-1.103-2.55c0-1.93 1.57-3.5 3.5-3.5.765 0 1.492.242 2.101.701a1 1 0 1 1-1.202 1.597 1.502 1.502 0 0 0-1.926 2.294 1 1 0 0 1 .043 1.414zm-1.181 3.182a1 1 0 0 1-.285 1.386 3.49 3.49 0 0 0-1.556 2.536c-.057.511-.49.89-.993.89-.707 0-1.056-.562-.996-1.11a5.48 5.48 0 0 1 2.444-3.985 1 1 0 0 1 1.385.284zM17 10c-3.86 0-7 3.141-7 7s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7m0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m3.221-6.212a1 1 0 0 1-.029 1.414l-2.212 2.124a2.35 2.35 0 0 1-1.653.671 2.38 2.38 0 0 1-1.664-.674l-1.132-1.108a1 1 0 0 1 1.399-1.43l1.132 1.108a.374.374 0 0 0 .522 0l2.223-2.134a1 1 0 0 1 1.414.029"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-team-check-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTeamCheckAlt;
